import React, {useState, useEffect} from 'react'
import { Row, Container, Form } from 'react-bootstrap';
import Contents from '../Common/Contents.js'
import {getAllBooks} from '../../actions/book';
import { useDispatch } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Navbar from '../Common/Navbar';
import Closing from '../Common/Closing';


const HomePage = () => {
  const dispatch = useDispatch();
  const ownerInformation = JSON.parse(localStorage.getItem('profile'));

  const [state, setState] = React.useState({
    checkedB: false,
  });
  const [search, setSearch] = useState('');
  
  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
  
  const searchChange = (e) =>{
    setSearch(e.target.value)
  }
  
  const handleSubmit = (event) =>{
    event.preventDefault();
    dispatch(getAllBooks(search));
  }
  return (
      <div>
          <Navbar />
          <br />
          <Container fluid="md">
            <Row>
              <form onSubmit = {handleSubmit}>
                <Form.Group>
                  <Form.Control onChange = {searchChange} value = {search} size="lg" type="text" placeholder="Search for the books by their subject's name. (Eg. Computer Science)" />
                </Form.Group>
              </form>
            </Row>
            <Row>
              <FormControlLabel
                    control={
                      <Switch
                        checked={state.checkedB}
                        onChange={handleChange}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Show in Maps"
                />
            </Row>
          </Container>          
          < br/>
          <Contents mybooks = {false} checkedStatus = {state.checkedB} />
          <Closing />
      </div>
  )
}

export default HomePage
